import { fetchCurrentUserToken, signOut } from '../modules/Auth/awsCognito'
import translateError from '../services/translateError'

const ResponseError = function (status, body) {
  this.status = status
  Object.keys(body).forEach((key) => {
    this[key] = body[key]
  })
}

let fetchOptions = {
  dispatch: null,
}

const configure = (options) => {
  fetchOptions = {
    ...fetchOptions,
    ...options,
  }
}

const defaultFetchOptions = {
  method: 'GET',
  mode: 'cors',
}

const appendTokenToOptions = (queryOptions, token) => {
  const options = { ...queryOptions }
  if (!options.headers) {
    options.headers = new Headers()
  }
  options.headers.append('Authorization', `Bearer ${token}`)
  return options
}

const parseResponse = (response) =>
  response
    .text()
    .then((body) => {
      try {
        return JSON.parse(body)
      } catch (err) {
        return {
          raw: body,
        }
      }
    })
    .then((responseBody) => {
      if (response.ok) {
        return responseBody
      } else {
        const error = new ResponseError(response.status, responseBody)
        error.message = translateError(error)
        throw error
      }
    })

const handleResponse = (url, options) => (response) => {
  if (response.status === 401 && fetchOptions.dispatch) {
    fetchOptions.dispatch(signOut())
  }
  if (response.status === 504) {
    return request(url, options)
  }
  return parseResponse(response)
}

const request = (url, options, tries = 0) =>
  window
    .fetch(url, options)
    .then(handleResponse(url, options))
    .catch((error) => {
      if (error.message === 'Failed to fetch' && tries < 3) {
        return request(url, options, tries + 1)
      }
      throw error
    })

const fetch = (url, options) =>
  fetchCurrentUserToken().then((token) => {
    options = appendTokenToOptions(
      {
        ...defaultFetchOptions,
        ...options,
      },
      token
    )
    if (fetchOptions.companyId) {
      url = url.replace('{companyId}', fetchOptions.companyId)
    }
    return request(url, options)
  })

fetch.post = (url, options) => {
  const requestHeaders = new Headers()
  requestHeaders.append('Accept', 'application/json')
  requestHeaders.append('Content-Type', 'application/json')

  return fetch(url, {
    method: 'POST',
    headers: requestHeaders,
    mode: 'cors',
    ...options,
  })
}

fetch.put = (url, options) => {
  const requestHeaders = new Headers()
  requestHeaders.append('Accept', 'application/json')
  requestHeaders.append('Content-Type', 'application/json')

  return fetch(url, {
    method: 'PUT',
    headers: requestHeaders,
    mode: 'cors',
    ...options,
  })
}

fetch.delete = (url, options) =>
  fetch(url, {
    method: 'DELETE',
    ...options,
  })

// the only case where we need to call our API without user being authenticated –
// when he needs to get temporary password again
const fetchNoAuth = (url, options) => {
  if (!url.includes('/resend-temp-pw')) return

  return request(url, options)
}

fetchNoAuth.post = (url, options) => {
  const requestHeaders = new Headers()
  requestHeaders.append('Accept', 'application/json')
  requestHeaders.append('Content-Type', 'application/json')

  return fetchNoAuth(url, {
    method: 'POST',
    headers: requestHeaders,
    mode: 'cors',
    ...options,
  })
}

export default fetch
export { configure, fetch, fetchNoAuth }
